import axios from "@/utils/axios";
import ApiClient from "@/domain/core/utils/apiClient";

export default new ApiClient(axios)
